import {useSession} from "next-auth/react";
import {useEffect, useState} from "react";
import axios from "@/lib/axios";

export default function useAxiosAuth(onInit){
    const {data : session} = useSession();
    const [init, setInit] = useState(false);

    useEffect(() => {
        //console.log(session?.user.token);
        if(session === undefined) return;
        const authInterceptor = axios.interceptors.request.use((config) => {
            if(!config.headers['Authorization']){
                config.headers['Authorization'] = `Bearer ${session?.user.token}`;
            }

            return config;
        });

        if(!init){
            setInit(true);
            onInit?.(axios);
        }

        return () => {
            axios.interceptors.request.eject(authInterceptor);
        }
    }, [session]);

    if(init) return axios;
    return null;
}